import React from 'react';
import { Box } from '@common-fe/common-fe';

import PERMISSIONS from '@/common/permissions';
import ROUTES from '@/common/routes';
import { useHasAccess } from '@/modules/core';
import Topbar from '@/modules/core/components/Topbar';
import { useBreadcrumbs } from '@/modules/core/hooks/useBreadcrumbs';
import { ScheduledReports } from '@/modules/Reports/ScheduledReport';
import theme from '@/styles/theme';

const PrefundInvoiceReportPage = () => {
  useBreadcrumbs([
    {
      route: ROUTES.NEW_REPORTS,
      title: 'Reports',
    },
    {
      route: ROUTES.SCHEDULED_REPORTS,
      title: 'Scheduled',
    },
  ]);
  const isHasPermission = useHasAccess([
    {
      permission: PERMISSIONS.REPORTS,
    },
  ]);
  if (!isHasPermission) {
    return null;
  }

  return (
    <Box width="100%" margin={{ top: '0' }} height="fit-content">
      <Topbar />
      <Box align="center" pad={{ bottom: 'spacing72' }}>
        <Box width={theme.defaultContentWidth}>
          <Box margin={{ top: 'spacing24' }}>
            <ScheduledReports />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default PrefundInvoiceReportPage;
